/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StringSegment } from './StringSegment';
import {
    StringSegmentFromJSON,
    StringSegmentFromJSONTyped,
    StringSegmentToJSON,
    StringSegmentToJSONTyped,
} from './StringSegment';

/**
 * 
 * @export
 * @interface EntityTagHeaderValue
 */
export interface EntityTagHeaderValue {
    /**
     * 
     * @type {StringSegment}
     * @memberof EntityTagHeaderValue
     */
    tag?: StringSegment;
    /**
     * 
     * @type {boolean}
     * @memberof EntityTagHeaderValue
     */
    isWeak?: boolean;
}

/**
 * Check if a given object implements the EntityTagHeaderValue interface.
 */
export function instanceOfEntityTagHeaderValue(value: object): value is EntityTagHeaderValue {
    return true;
}

export function EntityTagHeaderValueFromJSON(json: any): EntityTagHeaderValue {
    return EntityTagHeaderValueFromJSONTyped(json, false);
}

export function EntityTagHeaderValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntityTagHeaderValue {
    if (json == null) {
        return json;
    }
    return {
        
        'tag': json['tag'] == null ? undefined : StringSegmentFromJSON(json['tag']),
        'isWeak': json['isWeak'] == null ? undefined : json['isWeak'],
    };
}

export function EntityTagHeaderValueToJSON(json: any): EntityTagHeaderValue {
    return EntityTagHeaderValueToJSONTyped(json, false);
}

export function EntityTagHeaderValueToJSONTyped(value?: EntityTagHeaderValue | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tag': StringSegmentToJSON(value['tag']),
        'isWeak': value['isWeak'],
    };
}

